module.exports = __webpack_public_path__ + "img/category-casino.1821e144.png";